import { render, staticRenderFns } from "./PhoneLead.vue?vue&type=template&id=6064c11d&scoped=true&"
import script from "./PhoneLead.vue?vue&type=script&lang=ts&"
export * from "./PhoneLead.vue?vue&type=script&lang=ts&"
import style0 from "./PhoneLead.vue?vue&type=style&index=0&id=6064c11d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6064c11d",
  null
  
)

export default component.exports